import React from 'react'
import classnames from 'classnames';

export default ({ icons, iconName, className, width, height }) =>
  <svg className={classnames(className, iconName)} width={width} height={height}>
    <use xlinkHref={`${icons}#${iconName}`} />
  </svg>
